import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Modal } from '@mui/material';
import '../../../../scss/devicesConfiguration.scss';
import noImageAvailable from '../../../../assets/noImage_En.png';
import noImageAvailableSpanish from '../../../../assets/noImage_Es.png';
import noImageAvailableFrench from '../../../../assets/noImage_Fr.png';
import i18next, { t } from 'i18next';
import { imageSize } from '../../../../constant/variable';
import cloud from '../../../../assets/images/cloud.svg';
import { toast } from 'react-toastify';
import { UploadFileToServer } from '../../../../reduxToolkit/Contractor/ContractorApi';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 0.5,
    outline: 'none',
    border: 'none',
    '&:focus': {
        outline: 'none',
        border: 'none',
    },
};

const ChangeBackgroundModal = ({ open, handleClose, isIDLEBackgroundToChange, isPhotoinTimeClock, isPhotoInIdle }) => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [actualLanguage, setActualLanguage] = useState(null);
    const { i18n } = useTranslation();

    useEffect(() => {
        const currentLanguage = i18n.language;
        setActualLanguage(currentLanguage);
    }, [i18n.language]);

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            fileInputRef.current.files = files;
            onImageChange({ target: fileInputRef.current });
        }
    };

    const onImageChange = (e) => {
        const selectedFiles = e.target.files;
        const imageRegex = /\.(jpg|jpeg|png|gif)$/i;

        if (selectedFiles && selectedFiles.length > 0) {
            if (!imageRegex.test(selectedFiles[0].name)) {
                toast.error(t('error_file_format').toUpperCase());
            } else if (selectedFiles[0].size > imageSize) {
                toast.error(`${t('the_file_size_should_not_exceed').toUpperCase()} ${imageSize / 1024}KB.`);
            } else {
                setSelectedImage(selectedFiles[0]);
                setUploadSuccess(true);
            }
        }
    };

    const changeBackgroundForIdle = async () => {
        if (selectedImage) {
            try {
                let formData = new FormData();
                formData.append('id', 'daf51955-baa7-4aca-93a4-97d56799b810');
                if (isIDLEBackgroundToChange) {
                    formData.append('option', 'idle_image');
                } else {
                    formData.append('option', 'clock_image');
                }
                formData.append('file', selectedImage);
                await dispatch(UploadFileToServer(formData));

                setUploadSuccess(false);
                handleClose(false);
                window.location.reload();
            } catch (error) {
                toast.error(t('background_change_error').toUpperCase());
            }
        } else {
            toast.info(t('please_select_an_image_to_upload').toUpperCase());
        }
    };

    return (
        <Modal
            open={open}
            onClose={() => {
                setUploadSuccess(false);
                handleClose(false);
                setSelectedImage(null);
            }}
            sx={{
                outline: 'none',
            }}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
            className='modal--changeBackgroundModal'
        >
            <Box sx={style} className='section-modal'>
                <section className='closeModalBtn'>
                    <i
                        className='fa fa-times '
                        aria-hidden='true'
                        onClick={() => {
                            handleClose(true);
                            setSelectedImage(null);
                        }}
                    ></i>
                </section>{' '}
                <Box className='section--headerModal'>
                    <Typography className='typography--h1-titleModalChangeBackground' variant='h2' color='initial'>
                        {t('change_background')}
                    </Typography>{' '}
                </Box>{' '}
                <Box className='container-modal-d'>
                    <Box className='container-d-d'>
                        <label
                            htmlFor='file-input'
                            className='dotted-border-box  centerElements max-w-4'
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                        >
                            <img src={cloud} className='w-40' alt='submitupload' />
                            <input
                                type='file'
                                ref={fileInputRef}
                                id='file-input'
                                accept='image/*'
                                onChange={onImageChange}
                            />
                            <div className='drag-and-drop center-column-14-f '>
                                <p>
                                    {t('drag_your_file_or')}
                                    {t('click_to_upload')}
                                    <br /> <span>{`${t('max_size')} ${imageSize / 1024}KB`}</span>
                                </p>
                            </div>
                        </label>
                    </Box>
                    <Box className='container-preview'>
                        <Box className=' centerElements'>
                            <Typography variant='h2' color='initial' className='h2-preview--titlePreview'>
                                {t('preview')}
                            </Typography>
                        </Box>{' '}
                        {selectedImage && uploadSuccess ? (
                            <Box className='img-width-modal'>
                                <img
                                    className='img-modal-w '
                                    src={URL.createObjectURL(selectedImage)}
                                    alt={t('uploaded_image')}
                                />
                            </Box>
                        ) : actualLanguage === 'en' ? (
                            <Box>
                                <img
                                    className='img-width-modal'
                                    src={noImageAvailable}
                                    alt={t('the_image_does_not_exist')}
                                />
                            </Box>
                        ) : actualLanguage === 'sp' ? (
                            <Box>
                                <img
                                    className='img-width-modal'
                                    src={noImageAvailableSpanish}
                                    alt={t('the_image_does_not_exist')}
                                />
                            </Box>
                        ) : (
                            <Box>
                                <img
                                    className='img-width-modal'
                                    src={noImageAvailableFrench}
                                    alt={t('the_image_does_not_exist')}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>
                <Box className='fixed-buttons'>
                    <button
                        className='btn_cancel_background_gray_hover width100'
                        onClick={() => {
                            handleClose(false);
                            setSelectedImage(null);
                        }}
                    >
                        {t('cancel').toUpperCase()}
                    </button>
                    <button className='custom_primary_btn_dark width100' onClick={changeBackgroundForIdle}>
                        {t('change').toUpperCase()}
                    </button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ChangeBackgroundModal;
